import { PropsWithChildren } from 'react';

export const TabBodyWrapper = ({ children }: PropsWithChildren) => (
  <div className='w-full flex flex-col items-center min-h-[calc(100vh-166.25px)]'>
    {children}
  </div>
);
